// extracted by mini-css-extract-plugin
export var chip = "_40-9";
export var chipLabel = "_40-a";
export var close = "_40-7";
export var closeIcon = "_40-8";
export var error = "_40-6";
export var infoTooltip = "_40-2";
export var innerContainer = "_40-1";
export var input = "_40-b";
export var medium = "_40-5";
export var outerContainer = "_40-0";
export var small = "_40-4";
export var xSmall = "_40-3";